import { combineReducers } from 'redux';
import createAnalyticsReducer from '../../common/reducers/analytics';
import { SALES_ANALYTICS_REQUEST, SALES_ANALYTICS_SUCCESS, SALES_ANALYTICS_FAILURE } from './sales/actions';
import { OPERATIONS_ANALYTICS_REQUEST, OPERATIONS_ANALYTICS_SUCCESS, OPERATIONS_ANALYTICS_FAILURE } from './operations/actions';
import { HEAD_OFFICE_ANALYTICS_REQUEST, HEAD_OFFICE_ANALYTICS_SUCCESS, HEAD_OFFICE_ANALYTICS_FAILURE } from '../headOffice/analytics/actions';

const analytics = combineReducers({
	sales: createAnalyticsReducer({
		types: [SALES_ANALYTICS_REQUEST, SALES_ANALYTICS_SUCCESS, SALES_ANALYTICS_FAILURE],
		mapActionToKey: action => action.item
	}),
	operations: createAnalyticsReducer({
		types: [OPERATIONS_ANALYTICS_REQUEST, OPERATIONS_ANALYTICS_SUCCESS, OPERATIONS_ANALYTICS_FAILURE],
		mapActionToKey: action => action.item
	}),
	headOffice: createAnalyticsReducer({
		types: [HEAD_OFFICE_ANALYTICS_REQUEST, HEAD_OFFICE_ANALYTICS_SUCCESS, HEAD_OFFICE_ANALYTICS_FAILURE],
		mapActionToKey: action => action.item
	})
});

export default analytics;